<template>
  <div class="wh-100">
    <div class="left-btn">
      <el-button type="primary" icon="el-icon-circle-plus" @click="addLeft">新增报表</el-button>
    </div>
    <div class="list">
      <div class="item" v-for="(item, index) in leftTable" :key="index" :class="isSelect == index ? 'item btn' : 'item'" @click="selectBtn(index, item)">
        <div class="item-title" :title="item.name">{{ item.name }}</div>
        <el-button type="text" icon="el-icon-edit" title="修改" @click="modifyLeft(item)" :class="isSelect == index ? 'black' : ''"></el-button>
        <el-button type="text" icon="el-icon-delete" title="删除" @click="deleteTable(item,index)" :class="isSelect == index ? 'black' : ''"></el-button>
      </div>
    </div>
    <!-- 左边表格新增编辑开始 -->
    <el-dialog :title="leftTitle" :visible.sync="showLeft" width="500px" :close-on-click-modal="false" @close="closeLeft">
      <el-form label-width="100px" :rules="rules" :model="leftForm" ref="leftForm" v-if="showLeft">
        <!--  -->
        <el-form-item label="报表标题:" prop="name" style="width: 310px; margin-bottom: 30px">
          <el-input v-model="leftForm.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveLeft">确定</el-button>
          <el-button style="margin-right: 15px" @click="showLeft = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 左边表格新增编辑結束 -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      leftTable: [],
      isSelect: null,
      showLeft: false,
      leftTitle: "新增报表标题",
      leftForm: {},
      rules: {
        name: [
          {
            required: true,
            message: "不能为空",
            trigger: ["blur", "change"],
          },
        ]
      }
    }
  },
  created () {
    this.getUserDefinedStatements()
  },
  methods: {
    //获取左边数据
    async getUserDefinedStatements () {
      let vm = this;
      let resUer = await vm.$api.statement.getUserDefinedStatements(0);
      vm.leftTable = resUer.data;
      if (vm.leftTable.length > 0) {
        this.isSelect = 0;
        this.$emit('change', vm.leftTable[0])
      }
    },
    /* 选择报表 */
    selectBtn (i, row) {
      this.isSelect = i;
      this.$emit('change', row)
    },

    /* 新增左边报表 */
    addLeft () {
      this.leftForm = {
        name: '',
        id: ''
      }
      this.leftTitle = "新增报表标题";
      this.showLeft = true;
    },
    /* 左边编辑报表 */
    modifyLeft (row) {
      this.leftTitle = "编辑报表标题";
      this.leftForm = JSON.parse(JSON.stringify(row));
      this.showLeft = true;
    },
    /* 保存左边报表 */
    saveLeft () {
      let vm = this;
      let msg = "";
      if (vm.leftTitle == "新增报表标题") {
        vm.$api.statement.createUserDefinedStatement(0, vm.leftForm.name)
          .then((res) => {
            if (res.success) {
              vm.$message.success('新增成功');
              vm.showLeft = false;
              vm.getUserDefinedStatements();
            }
          });
      } else {
        vm.$api.statement.modifyUserDefinedStatement(vm.leftForm.id, vm.leftForm.name)
          .then((res) => {
            if (res.success) {
              vm.$message.success(res.errorStr);
              vm.getUserDefinedStatements();
              vm.showLeft = false;
            }
          });
      }
    },
    /* 删除左右边报表 */
    deleteTable (row, index) {
      let vm = this
      this.$confirm('此操作将删除您选中的报表, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vm.$api.statement.deleteUserDefinedStatement(row.id).then(res => {
          if (res.success) {
            if (vm.leftTable.length === 1) {
              vm.leftTable = []
            }
            else {
              vm.leftTable.splice(index, 1)
              this.isSelect = 0;
              this.$emit('change', vm.leftTable[0])
            }
          }
        })
      }).catch(() => {
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
.wh-100 {
  width: 100%;
  height: 100%;
}
</style>